import React, { useState, useContext, Fragment } from "react";
import { useAuth } from "../hooks/AuthProvider";
import { useNavigate } from "react-router-dom";
import './ForgotPassword.css'; 
import { LanguageContext } from '../context/LanguageContext';
import authTranslations from '../languages/auth.json';


const EmailIcon = ({ className }) => (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
);
const ChevronLeft = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
);

export const ForgotPassword = () => {
    const { lang } = useContext(LanguageContext);
    const tRoot = authTranslations[lang] || authTranslations.en;
    const t = tRoot.ForgotPassword;

    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const auth = useAuth();
    const navigate = useNavigate();

    const onFormSubmit = async (e) => {
        e.preventDefault();
        setEmailError("");
        setSuccessMessage("");
        const normalizedEmail = String(email || "").trim();

        let isValid = true;

        if ("" === normalizedEmail) {
            setEmailError(t.errorRequiredEmail);
            isValid = false;
        } 
        else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(normalizedEmail)) {
            setEmailError(t.errorInvalidEmail);
            isValid = false;
        }

        if (!isValid) return;
        
        setSubmitting(true);

        try {
            await auth.forgotPasswordAction(normalizedEmail);
            
            setSuccessMessage(t.messageSuccess);
            
            setTimeout(() => {
                navigate('/verify-reset-code', { state: { email: normalizedEmail } });
            }, 1500);

        } catch (error) {
            setSuccessMessage('');
            setEmailError(t.errorEmailFailed);
        } finally {
            setSubmitting(false);
        }
    };

    const goBack = () => {
        navigate(-1);
    };
    
    return (
        <div className="auth-page-wrapper">
            <div className="auth-center-container">
                <div className="auth-card-wrapper auth-single-card"> 
                    
                    <div className="auth-form-container"> 
                        
                        <button className="auth-back-button" onClick={goBack}>
                            <ChevronLeft />
                            {t.buttonBack}
                        </button>

                        <div className="auth-header-block">
                            <h2>{t.title}</h2>
                            <p className="auth-subtitle">{t.subtitle}</p>
                        </div>
                        
                        <form onSubmit={onFormSubmit}>
                            
                            <div className="auth-form-group">
                                <label htmlFor="forgot-email">
                                    <EmailIcon className="auth-label-icon" />
                                    {t.labelEmail}
                                </label>
                                <div className={`auth-input-wrapper ${emailError ? 'has-error' : ''}`}>
                                    <input
                                        className="auth-form-input"
                                        value={email}
                                        type="email"
                                        id="forgot-email"
                                        name="email"
                                        placeholder={t.placeholderEmail}
                                        onChange={ev => setEmail(ev.target.value)}
                                        required
                                        disabled={submitting}
                                    />
                                </div>
                                {emailError && <span className="auth-error-message">{emailError}</span>}
                                {successMessage && <span className="auth-success-message">{successMessage}</span>}
                            </div>
                            
                            <button
                                className="auth-submit-btn"
                                type="submit"
                                disabled={submitting}
                            >
                                {submitting ? t.buttonSending : t.buttonSendCode}
                            </button>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

